import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

import { TCustomProfileColors } from 'types/GlobalCustomization'

export const selectBackgroundColor = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.CustomizationStore.background_colors
  ],
  (backgroundColors) => (backgroundColors ? backgroundColors.default : null)
)

export const selectCustomization = createSelector(
  [(state: ApplicationState) => state.CustomizationStore],
  (customization) => customization
)

export const selectProfileColors = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.CustomizationStore.profile_colors
  ],
  (colors): TCustomProfileColors => {
    if (colors) {
      return colors
    }

    return {
      primary: null,
      secondary: null,
      tertiary: null,
      quaternary: null,
      quintary: null,
      senary: null,
      septenary: null,
      octonary: null,
      nonary: null,
      denary: null
    }
  }
)
